<template>
	<OutstandingRequirement></OutstandingRequirement>
</template>
<script type="text/javascript">
import {OutstandingRequirement} from '../components'
	export default{
		name: 'GIoutstandingRequirementContainer',
		components:{
			OutstandingRequirement
		}
	}
</script>


// WEBPACK FOOTER //
// src/Osm/GIPolicy/containers/GIOutstandingRequirementContainer.vue